import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { Link, useSearchParams } from "react-router-dom";
import { Building2, ArrowRight, Info } from "lucide-react";

const fmt = (n) => new Intl.NumberFormat("pt-BR").format(n || 0);

export default function Projetos() {
  const [products, setProducts] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [params] = useSearchParams();
  const filterProd = params.get("product");

  useEffect(() => {
    Promise.all([clientApi.get("/products"), clientApi.get("/campaigns")]).then(([p, c]) => {
      setProducts(p.data); setCampaigns(c.data);
    });
  }, []);

  const productsFiltered = filterProd ? products.filter((p) => p.id === filterProd) : products;

  return (
    <div className="space-y-8" data-testid="cliente-projetos-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Portfólio</div>
        <h1 className="font-display text-3xl md:text-4xl">Projetos & Campanhas</h1>
        <p className="text-sm text-neutral-400 mt-2">Ficha técnica de cada produto imobiliário e histórico das campanhas.</p>
      </div>

      {productsFiltered.map((p) => {
        const camps = campaigns.filter((c) => c.product_id === p.id);
        return (
          <section key={p.id} className="border border-white/10 rounded-xl overflow-hidden" data-testid={`projeto-${p.id}`}>
            <div className="grid md:grid-cols-2 gap-0">
              <div className="aspect-video md:aspect-auto bg-neutral-900 relative">
                {p.photo && <img src={p.photo} alt={p.name} className="w-full h-full object-cover" />}
              </div>
              <div className="p-6 md:p-8">
                <div className="font-display text-3xl leading-tight mb-2">{p.name}</div>
                <div className="text-sm text-neutral-500 mb-4">{p.developer}</div>
                <dl className="grid grid-cols-2 gap-y-3 text-xs">
                  <FS k="Tipo" v={p.type} />
                  <FS k="VGV" v={p.vgv} />
                  <FS k="Tipologias" v={p.typologies} />
                  <FS k="Metragens" v={p.sizes} />
                  <FS k="Cidade" v={p.city} />
                  <FS k="Período" v={p.period} />
                </dl>
              </div>
            </div>

            {camps.length > 0 && (
              <div className="border-t border-white/10 p-6 md:p-8">
                <div className="text-xs uppercase tracking-widest text-accent-orange mb-4">Campanhas</div>
                <div className="grid md:grid-cols-2 gap-3">
                  {camps.map((c) => (
                    <Link
                      key={c.id}
                      to={`/cliente/acompanhamento?campaign=${c.id}`}
                      className="group flex items-center gap-3 border border-white/10 rounded-lg p-4 hover:border-accent-orange hover:bg-white/[0.02] transition"
                      data-testid={`campaign-link-${c.id}`}
                    >
                      <div className="flex-1">
                        <div className="font-semibold text-sm">{c.name}</div>
                        <div className="text-[11px] text-neutral-500">{c.period} · {c.status}</div>
                      </div>
                      <ArrowRight className="w-4 h-4 text-neutral-500 group-hover:text-accent-orange transition-colors" />
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </section>
        );
      })}

      {productsFiltered.length === 0 && (
        <div className="border border-dashed border-white/10 rounded-xl p-10 text-center text-sm text-neutral-500 flex flex-col items-center gap-2">
          <Info className="w-6 h-6 opacity-50" />
          Nenhum produto encontrado.
        </div>
      )}
    </div>
  );
}

function FS({ k, v }) {
  if (!v) return null;
  return (
    <>
      <dt className="text-neutral-500 uppercase tracking-widest text-[10px]">{k}</dt>
      <dd className="text-white">{v}</dd>
    </>
  );
}
